import { Column } from '@miq/catalog';
import { ValidatorFn } from '@angular/forms';
import { GeoOptions } from '@records/records-search/save-search/save-search-dialog.component';
import { CorporateReportTrackingData } from './report-list.config';

export interface ReportListColumn extends Pick<Column, 'field' | 'header' | 'displayFn' | 'sortable'> {
  toggler: {
    expand_icon?: string;
    expanded_icon?: string;
    indent?: boolean;
    width?: string;
  };
  maxlength: number;
  displayFn: (dataObj) => string;
  subtitleCellFormater: (dataObj) => string;
  width: string;
  filterable: boolean;
  editable: boolean;
  checkbox: boolean;
  disabled: boolean;
  defaultSort: boolean;
  sortOrder: number;
  controlOptions: {
    validators: ValidatorFn[];
  };
  rowClick: (row) => void;
}

export enum ReportTemplate {
  CorporateReport = 3,
  CorporateTrends = 4,
  NationalTimReport = 5,
  TopTransactionsReport = 6,
  FinalizeHistoricalData = 7,
  DownloadReportList = 13,
  CorporateReportMulti = 9,
  MoveInOutReport = 10,
}

export enum Sort {
  DESC = 'desc',
  ASC = 'asc',
}

export interface CorporateReportOption {
  key: ReportTemplate;
  value: string;
  trackingObj?: Partial<CorporateReportTrackingData>;
}

export interface ReportListSettings {
  sortColumn: string;
  sortOrder: 'desc' | 'asc';
}

export enum GeoFieldKeys {
  Markets = 'markets',
  Divisions = 'divisions',
  SubMarkets = 'submarkets',
  PropertyTypes = 'propertyTypes',
  StatisticalPropertiesSet = 'statisticalPropertiesSet',
  PropertySet = 'propertySet',
}

export interface GeoFieldInfo {
  key: GeoFieldKeys;
  onload: boolean;
  required: boolean;
  uri?: string;
  dependent?: GeoFieldKeys;
  data?: GeoOptions[];
  tooltip?: string;
}
